// Version : 0.0.1
// Author : AGALYA
// LastEdit : SHIYAM
// Last ADD : changed the file and folder name with hyphen
// MODFIED DATE : 05-08-2025

const PurposeOfLoanActionTypes = {
	/** ***************** ADD PURPOSE OF LOAN DETAILS START *********************** */
	ADD_PURPOSE_OF_LOAN_DETAILS_START: 'add_purpose_of_loan_details_start',
	ADD_PURPOSE_OF_LOAN_DETAILS_SUCCESS: 'add_purpose_of_loan_details_success',
	ADD_PURPOSE_OF_LOAN_DETAILS_FAILURE: 'add_purpose_of_loan_details_failure',
	ADD_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET: 'add_purpose_of_loan_details_response_reset',
	ADD_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED: 'add_purpose_of_loan_details_response_changed',
	/** ***************** ADD PURPOSE OF LOAN DETAILS END *********************** */

	/** ***************** UPDATE PURPOSE OF LOAN DETAILS START *********************** */
	UPDATE_PURPOSE_OF_LOAN_DETAILS_START: 'update_purpose_of_loan_details_start',
	UPDATE_PURPOSE_OF_LOAN_DETAILS_SUCCESS: 'update_purpose_of_loan_details_success',
	UPDATE_PURPOSE_OF_LOAN_DETAILS_FAILURE: 'update_purpose_of_loan_details_failure',
	UPDATE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET: 'update_purpose_of_loan_details_response_reset',
	UPDATE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED:
		'update_purpose_of_loan_details_response_changed',
	/** ***************** UPDATE PURPOSE OF LOAN DETAILS END *********************** */

	/** ***************** GET PURPOSE OF LOAN DETAILS START *********************** */
	GET_PURPOSE_OF_LOAN_LIST_START: 'get_purpose_of_loan_list_start',
	GET_PURPOSE_OF_LOAN_LIST_SUCCESS: 'get_purpose_of_loan_list_success',
	GET_PURPOSE_OF_LOAN_LIST_FAILURE: 'get_purpose_of_loan_list_failure',
	GET_PURPOSE_OF_LOAN_LIST_RESPONSE_RESET: 'get_purpose_of_loan_list_response_reset',
	GET_PURPOSE_OF_LOAN_LIST_RESPONSE_CHANGED: 'get_purpose_of_loan_list_response_changed',
	/** ***************** GET PURPOSE OF LOAN DETAILS END *********************** */

	/** ***************** FETCH PURPOSE OF LOAN DETAILS START *********************** */
	FETCH_PURPOSE_OF_LOAN_DETAILS_START: 'fetch_purpose_of_loan_details_start',
	FETCH_PURPOSE_OF_LOAN_DETAILS_SUCCESS: 'fetch_purpose_of_loan_details_success',
	FETCH_PURPOSE_OF_LOAN_DETAILS_FAILURE: 'fetch_purpose_of_loan_details_failure',
	FETCH_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET: 'fetch_purpose_of_loan_details_response_reset',
	FETCH_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED:
		'fetch_purpose_of_loan_details_response_changed',
	/** ***************** FETCH PURPOSE OF LOAN DETAILS END *********************** */

	/** ***************** DELETE PURPOSE OF LOAN DETAILS START *********************** */
	DELETE_PURPOSE_OF_LOAN_DETAILS_START: 'delete_purpose_of_loan_details_start',
	DELETE_PURPOSE_OF_LOAN_DETAILS_SUCCESS: 'delete_purpose_of_loan_details_success',
	DELETE_PURPOSE_OF_LOAN_DETAILS_FAILURE: 'delete_purpose_of_loan_details_failure',
	DELETE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET: 'delete_purpose_of_loan_details_response_reset',
	DELETE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED:
		'delete_purpose_of_loan_details_response_changed',
	/** ***************** DELETE PURPOSE OF LOAN DETAILS END *********************** */

	/** ***************** UPDATE PURPOSE OF LOAN PUBLISH STATUS START *********************** */
	UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_START: 'UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_START',
	UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_SUCCESS: 'UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_SUCCESS',
	UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_FAILURE: 'UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_FAILURE',
	UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_RESPONSE_RESET:
		'UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_RESPONSE_RESET',
	UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_RESPONSE_CHANGED:
		'UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_RESPONSE_CHANGED',
	/** ***************** UPDATE PURPOSE OF LOAN PUBLISH STATUS END *********************** */
};

export default PurposeOfLoanActionTypes;
